<h2 class="content-title-block">
    <div class="content-title">
        <img class="icon" [src]="IconUrl$ | async"><span class="border-start ms-2 me-1"></span>
        {{ Title$ | async }}
    </div>
    <app-favorite-button [isFavorite]="isFavorite$ | async" class="float-right" (toggle)="ToggleFaveStar($event)"></app-favorite-button>
</h2>
